import styled, { StyledComponent } from "styled-components";

const FieldSet: StyledComponent<"fieldset", any, {}, never> = styled.fieldset`
  border: medium none;
  margin: 0 0 10px;
  min-width: 100%;
  padding: 0;
  width: 100%;
`;

const Input: any = styled.input`
 margin:0;
 margin-right:5px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 0px;

  &:hover {
    transition: border-color 0.3s ease-in-out;
    border: 1px solid #aaa;
  }
  &:focus {
    outline: 0;
    border: 1px solid #aaa;
  }
  :first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  :last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items:center;
`;

const Error = styled.div`
  color: #ff0000;
`;

export { FieldSet, Input, Error,  InputWrapper };
